import React, { useMemo, useState } from 'react';
import BsModal from '../Common/BsModal';
import ajaxConfig from '../../util/remote/ajaxConfig';
import Notification from '../Common/Notification';


const ChangeUserRoleModal = ({
  show,
  onClose,
  onSuccess,
  roles = [],
  user,        // optional, for nicer copy
}) => {
  const [role, setRole] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [notify, setNotify] = useState(null);

  

  const canSubmit = !!role && !submitting;

  const handleSubmit = async () => {
      setNotify(null);
      setSubmitting(true);
      const server_response = await ajaxConfig.changeUserRole({user_id: user.user_id, role_id: role});
    setSubmitting(false);
      if(server_response.status === "OK"){
        setNotify(<Notification type="success" message="Role changed successfully!" />);
        setTimeout(() => {
            // reset & close
            setRole('');
            onSuccess?.();
            setNotify(null);
        }, 1000);
        
      } else {
        setNotify(<Notification type="danger" message={server_response.message || 'Failed to send invite.'} />);
      }
     
   
  };

  const renderRoleOptions = () => {
    if(Array.isArray(roles) && roles.length > 0) {
      return roles.map((r) => (
        <option key={r.id} value={r.id}>
          {r.role_name}
        </option>
      ));
    }
    return <></>;
  };

  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Change User Role"
      footer={
        <>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={!canSubmit}
          >
            {submitting ? (
              <>
                <i className="fa fa-spinner fa-spin mr-1" /> Updating…
              </>
            ) : (
              <>
                <i className="fa fa-paper-plane mr-1" /> Change Role
              </>
            )}
          </button>
        </>
      }
    >
      <div className="text-dark">
      
        <div className="alert alert-info py-2">
          <i className="fa fa-info-circle mr-1" />
          <b>Heads up:</b> You are about to change the role for{' '}
          <b>{user?.full_name || 'this user'}</b>. This will update their
          permissions immediately.
        </div>

        {notify}


        <div className="form-group">
          <label htmlFor="inviteRole">Role</label>
          <select
            className="form-control"
            id="inviteRole"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            required
          >
            <option value="">Select a role…</option>
            {renderRoleOptions()}
          </select>
          <small className="form-text text-muted">
            <b>Admin</b>: full access • <b>Manager</b>: manage plans/routers/users •{' '}
            <b>Support</b>: view and assist sessions • <b>Billing</b>: invoices & payments •{' '}
            <b>Viewer</b>: read‑only
          </small>
        </div>

        
      </div>
    </BsModal>
  );
};

export default ChangeUserRoleModal;
